'use client';

import { useState } from 'react';

interface ExerciseViewProps {
  sessionId: string;
}

export default function ExerciseView({ sessionId }: ExerciseViewProps) {
  const [status, setStatus] = useState<'ready' | 'in_progress' | 'completed'>('ready');

  const handleStart = () => {
    setStatus('in_progress');
    // Track telemetry event
    fetch('/api/telemetry', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        events: [{
          type: 'action:start',
          participantId: 'demo-user',
          timestamp: new Date().toISOString(),
          data: { sessionId },
        }],
      }),
    });
  };

  const handleComplete = () => {
    setStatus('completed');
    // Track telemetry event
    fetch('/api/telemetry', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        events: [{
          type: 'action:complete',
          participantId: 'demo-user',
          timestamp: new Date().toISOString(),
          data: { sessionId },
        }],
      }),
    });
  };

  return (
    <div className="border rounded-lg p-6 bg-white dark:bg-gray-900">
      <h2 className="text-xl font-semibold mb-4">Exercise Content</h2>

      {status === 'ready' && (
        <div className="text-center py-12">
          <p className="text-gray-500 mb-6">
            This is a template exercise. Replace this content with your actual exercise.
          </p>
          <button
            onClick={handleStart}
            className="px-6 py-3 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition"
          >
            Start Exercise
          </button>
        </div>
      )}

      {status === 'in_progress' && (
        <div className="py-8">
          <div className="bg-gray-100 dark:bg-gray-800 rounded-lg p-8 text-center mb-6">
            <p className="text-lg text-gray-600 dark:text-gray-400">
              Exercise in progress...
            </p>
            <p className="text-sm text-gray-500 mt-2">
              [Your exercise content goes here]
            </p>
          </div>
          <div className="text-center">
            <button
              onClick={handleComplete}
              className="px-6 py-3 bg-green-500 text-white rounded-lg hover:bg-green-600 transition"
            >
              Complete Exercise
            </button>
          </div>
        </div>
      )}

      {status === 'completed' && (
        <div className="text-center py-12">
          <div className="text-5xl mb-4">✓</div>
          <h3 className="text-2xl font-semibold text-green-600 mb-2">
            Exercise Completed!
          </h3>
          <p className="text-gray-500">
            Your results have been recorded.
          </p>
          <a
            href={`/results?s=${sessionId}`}
            className="inline-block mt-6 px-6 py-3 bg-gray-800 text-white rounded-lg hover:bg-gray-700 transition"
          >
            View Results
          </a>
        </div>
      )}
    </div>
  );
}
